import React, { FC, ReactNode } from 'react';
import { JCBLogo } from 'src/atoms/card_brands/JCBLogo';
import { DiscoverLogo } from 'src/atoms/card_brands/DiscoverLogo';
import { VisaLogo } from 'src/atoms/card_brands/VisaLogo';
import { MasterCardLogo } from 'src/atoms/card_brands/MasterCardLogo';
import { AmexLogo } from 'src/atoms/card_brands/AmexLogo';
import { DinersLogo } from 'src/atoms/card_brands/DinersLogo';

type LogoWrapperProps = {
  children: ReactNode;
};

const LogoWrapper: FC<LogoWrapperProps> = ({ children }) => {
  return (
    <div className="flex h-10 flex-shrink-0 items-center justify-center rounded-md border border-gray-200 bg-white px-2 py-2 shadow-sm transition-all hover:border-gray-300 hover:shadow sm:w-auto [&>svg]:h-6 [&>svg]:w-auto">
      {children}
    </div>
  );
};

const VMBrands = () => {
  return (
    <>
      <LogoWrapper>
        <VisaLogo />
      </LogoWrapper>
      <LogoWrapper>
        <MasterCardLogo />
      </LogoWrapper>
    </>
  );
};

const JADDBrands = () => {
  return (
    <>
      <LogoWrapper>
        <JCBLogo />
      </LogoWrapper>
      <LogoWrapper>
        <AmexLogo />
      </LogoWrapper>
      <LogoWrapper>
        <DinersLogo />
      </LogoWrapper>
      <LogoWrapper>
        <DiscoverLogo />
      </LogoWrapper>
    </>
  );
};

type Props = {
  isVmAvailable: boolean;
  isJaddAvailable: boolean;
};

// TODO:O4 このデザインはテスト用の仮おきなのでレビュー不要です
// 後から修正します
export const MulpayAvailableBrandList: FC<Props> = ({
  isVmAvailable,
  isJaddAvailable,
}) => {
  // 利用可能なブランドがない場合は何も表示しない
  if (!isVmAvailable && !isJaddAvailable) {
    return null;
  }

  return (
    <div className="flex-1 space-y-2.5">
      <div>
        <h3 className="text-sm font-semibold text-gray-900">お支払い方法</h3>
        <p className="mt-0.5 text-xs leading-relaxed text-gray-600">
          現在こちらの加盟店では以下のブランドのクレジットカードがご利用いただけます
        </p>
      </div>

      {/* カードブランドロゴ */}
      <div className="flex flex-wrap items-center gap-1 sm:justify-evenly">
        {isVmAvailable && <VMBrands />}
        {isJaddAvailable && <JADDBrands />}
      </div>
    </div>
  );
};
